<template>
  <div class="page-birthday-entity-list-2020">
    <img :src="require('@/pages/2020/Birthday/assets/img/entity/banner_01.png')"
         alt="banner"
    />
    <count-down v-if="countDown && countDown.show"
                class="page-birthday-entity-list-2020-count-down-block"
                :desc-font-size="42"
                desc-bold
                :start="countDown.currentTime"
                :end="countDown.endTime"
                :desc="countDown.desc"
                :block-bg-img="require('@/pages/2020/Birthday/assets/img/entity/count_down_block.png')"
                :item-bottom="50"
    />
    <img :src="require('@/pages/2020/Birthday/assets/img/entity/banner_after.png')"
         alt="banner"
    />
    <div v-for="(block, index) in blocks"
         :key="index"
         class="entity-block-list"
    >
      <img :src="require(`@/pages/2020/Birthday/assets/img/entity/block_title_0${index + 1}.jpg`)"
           alt="entity-block-list-title"
      />
      <div v-for="item in block.list"
           :key="`${item.type}-${item.id}`"
           class="entity-block-list-item"
           @click="handleToDetail(item)"
           v-ym-report:ANNIVERSARY_2020_BRANCH_ENTITY_LIST_EXPOSURE="{ targetType: item.type, targetId: item.id, name: '实物分会场列表' }"
      >
        <img :src="require(`@/pages/2020/Birthday/assets/img/entity/info_${item.id}.png`)" alt="info">
        <img :src="require(`@/pages/2020/Birthday/assets/img/entity/product_${item.id}.png`)" alt="product">
      </div>
    </div>
    <img :src="require('@/pages/2020/Birthday/assets/img/entity/footer.png')"
         alt="footer"
    />
    <back-btn target-type="entity"
              :show="showToMajor"
              :status="status"
    />
  </div>
</template>

<script>
  import { before, decorator } from 'ym-reporter-vue';
  import { locationHref } from '@/utils';
  import CountDown from '@/components/CountDown';
  import BackBtn from '@/pages/2020/Birthday/components/BackToActivityIndexBtn';
  import { getBranchData } from '@/services/birthday-2020';

  export default {
    name: 'BirthdayEntityList2020',
    components: {
      BackBtn,
      CountDown,
    },
    data() {
      return {
        showToMajor: false,
        blocks: [],
        countDown: null,
        status: '',
      };
    },
    methods: {
      async fetchData() {
        const data = await getBranchData('entity');
        this.showToMajor = data.showToMajor;
        this.blocks = data.blocks;
        this.countDown = data.countDown;
        this.status = data.status || 'birthday';
      },
      @decorator(before(function (item) {
        const params = {
          targetId: item.id,
          targetType: item.type,
          name: '实物分会场列表',
          ymReporterRecordEntrySource: true,
        };
        this.$reporter.report('ANNIVERSARY_2020_BRANCH_ENTITY_LIST_CLICK', params);
      }))
      handleToDetail(item) {
        const path = `https://m.youthmba.com/entity/${item.id}`;
        console.log('path', path);
        locationHref(path);
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-birthday-entity-list-2020 {
    box-sizing: border-box;
    width: 100%;
    min-height: 100%;
    padding-bottom: 160px;
    background: @color-white;

    img {
      width: 100%;
      display: block;
    }

    &-count-down-block {
      background: #adeeed;
      /deep/ .count-down-desc {
        margin-top: 14px;
      }
    }
  }

</style>
